  
  // Table_3.jsx : 주문출고 상태 (모달)
  
import { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "../../context/AuthContext";
import "../../styles/Table.css";

const Table_3 = ({
  ProductCode,
  OBserial,
  orderQty,
  showTable_3,
  setShowTable_3,
}) => {
  const { Server_IP, token } = useAuth();
  const [items, setItems] = useState([]);
  const [totalQty, setTotalQty] = useState(0);
  const [remainingQty, setRemainingQty] = useState(0);
  const [selectedRowId, setSelectedRowId] = useState(null);

  const columnWidths = ["60px", "100px", "100px", "70px", "auto"];
  const columnAligns = ["center", "center", "center", "right", "center"];

  const handleRowClick = (index) => {
    setSelectedRowId(index);
  };

  useEffect(() => {
    if (!showTable_3 || !ProductCode || !OBserial) return;

    const fetchData = async () => {
      try {
        const { data } = await axios.post(
          `${Server_IP}/api/getShippingInfo/`,
          { ProductCode, OBserial },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        setItems(data);

        const sum = data.reduce(
          (acc, row) => acc + Number(row.Qty || 0),
          0
        );
        setTotalQty(sum);
        setRemainingQty(orderQty - sum);
      } catch (error) {
        console.error("데이터 불러오기 실패", error);
      }
    };

    fetchData();
  }, [showTable_3, ProductCode, OBserial, orderQty, token, Server_IP]);

  const handleClose = () => {
    setShowTable_3(false);
    setItems([]);
    setSelectedRowId(null);
  };
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const year = dateString.slice(0, 2);
    const month = dateString.slice(2, 4);
    const day = dateString.slice(4, 6);
    return `20${year}/${month}/${day}`;
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ width: "600px" }}>
        <div style={{ maxHeight: "280px", overflowY: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                {["순번", "주문일", "배송일", "수량", "상태"].map(
                  (label, idx) => (
                    <th
                      key={idx}
                      style={{
                        width: columnWidths[idx],
                        textAlign: columnAligns[idx],
                        padding: "8px",
                        backgroundColor: "#d3d3d3",
                        borderBottom: "1px solid #ddd",
                        position: "sticky",
                        top: 0,
                      }}
                    >
                      {label}
                    </th>
                  )
                )}
              </tr>
            </thead>
            <tbody>
              {items.map((item, index) => (
                <tr
                  key={`${item.OBserial}-${index}`}
                  style={{
                    backgroundColor: selectedRowId === index ? "#a8f1c4" : "transparent",
                    cursor: "pointer",
                  }}
                  onClick={() => handleRowClick(index)}
                >
                  <td style={{ padding: "8px", textAlign: columnAligns[0], borderBottom: "1px solid #ddd" }}>{index + 1}</td>
                  <td style={{ padding: "8px", textAlign: columnAligns[1], borderBottom: "1px solid #ddd" }}>
                    {formatDate(item.OrderDate)}
                  </td>
                  <td style={{ padding: "8px", textAlign: columnAligns[2], borderBottom: "1px solid #ddd" }}>
                    {formatDate(item.DeliveryDate)}
                  </td>
                  <td style={{ padding: "8px", textAlign: columnAligns[3], borderBottom: "1px solid #ddd" }}>{item.Qty}</td>
                  <td style={{ padding: "8px", textAlign: columnAligns[4], borderBottom: "1px solid #ddd" }}>{item.etc}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <hr className="divider" />

        <div className="footer-row">
          <label className="footer-label">합계</label>
          <input
            type="text"
            value={totalQty}
            readOnly
            className="footer-input"
          />
          <label className="footer-label">잔량</label>
          <input
            type="text"
            value={remainingQty}
            readOnly
            className="footer-input"
          />
          <button onClick={handleClose} className="close-btn">
            닫기 ✕
          </button>
        </div>
      </div>
    </div>
  );
};

export default Table_3;
